(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 67099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77058);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var Header = function Header(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var setSideMenuShow = _ref.setSideMenuShow;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("header", true)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "md:block hidden border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("border-grayBackground")),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "wrapper mx-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex flex-row py-2 items-center justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "pr-[36px] relative group",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm text-white font-bold" // id={
                  //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
                  //     ? "sub-menu-prelaunch-header"
                  //     : ""
                  // }
                  ,
                  children: "Vybeful"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-border"), " rounded-full px-3 pb-1 mr-0 h-[30px] flex justify-center items-center w-104px text-center"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/".concat((_process$env$NEXT_PUB = "Vybeful") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm h-[16px] font-semibold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("text-white", true)),
                  children: t("key_web_apply")
                })
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "wrapper-no-padding mx-auto ".concat( false ? 0 :  false ? 0 : "py-4", " sm:px-9 px-4"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "flex flex-row items-center justify-between",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden cursor-pointer w-[150px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 20
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu.svg",
            width: 29,
            height: 20,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block cursor-pointer w-[30px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 22
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu_mobile.svg",
            width: 30,
            height: 22,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:block hidden",
            style: {
              height:  false ? 0 :  false ? 0 : 52.8
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_vybeful.png",
              width:  false ? 0 :  false ? 0 : 182,
              height:  false ? 0 :  false ? 0 : 52.8,
              layout: "fixed",
              alt: "".concat("Vybeful", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:hidden block",
            style: {
              height:  false ? 0 :  false ? 0 : 34
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_vybeful.png",
              width:  false ? 0 :  false ? 0 : 120,
              height:  false ? 0 :  false ? 0 : 34,
              layout: "fixed",
              alt: "".concat("Vybeful", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block w-[30px]",
          children: "\xA0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden w-[150px]",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/guides",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-gradient"), " flex justify-center items-center w-150px h-40px rounded-full uppercase cursor-pointer"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "text-white text-base font-bold",
                children: "Guides"
              })
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Header);

/***/ }),

/***/ 92063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var SideMenu = function SideMenu(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var sideMenuShow = _ref.sideMenuShow,
      setSideMenuShow = _ref.setSideMenuShow,
      sideMenuHeaderShow = _ref.sideMenuHeaderShow,
      setSideMenuHeaderShow = _ref.setSideMenuHeaderShow;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "fixed top-0 left-0 ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-black7", true), " h-screen overflow-y-auto w-305px ").concat(sideMenuShow ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0", " transition-all duration-300 h-full z-[999]"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "pt-10 pl-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "cursor-pointer inline-block",
          onClick: function onClick() {
            return setSideMenuShow(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 17 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.646446 1.35355C0.451185 1.15829 0.451185 0.841709 0.646446 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L8.5 7.79289L15.6464 0.646447C15.8417 0.451184 16.1583 0.451184 16.3536 0.646447C16.5488 0.841709 16.5488 1.15829 16.3536 1.35355L9.20711 8.5L16.3536 15.6464C16.5488 15.8417 16.5488 16.1583 16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536L8.5 9.20711L1.35355 16.3536C1.15829 16.5488 0.841709 16.5488 0.646447 16.3536C0.451185 16.1583 0.451185 15.8417 0.646447 15.6464L7.79289 8.5L0.646446 1.35355Z",
              fill: (0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("svg-white")
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        // id={
        //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
        //     ? "sub-menu-prelaunch"
        //     : ""
        // }
        className: "border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2"), " pt-7 pb-4 pl-8"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-bold cursor-pointer") // onClick={() => setSideMenuHeaderShow(!sideMenuHeaderShow)}
          ,
          children: "Vybeful"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3 border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2")),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Home"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/guides",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Guides"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/".concat((_process$env$NEXT_PUB = "Vybeful") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Apply"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/about",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "About"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/contact",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Contact"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3",
        children: [ false && /*#__PURE__*/0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "/cookie-policy",
          className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
          children: "Cookies"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/legal",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Legal"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/sitemap.xml",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Sitemap"
          })
        })]
      })]
    }), sideMenuShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: {
        backgroundColor: "rgba(89, 89, 89, 0.45)",
        width: "100%",
        height: "100%",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 500
      },
      onPress: function onPress() {
        return setSideMenuShow(false);
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SideMenu);

/***/ }),

/***/ 82748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _src_DAO__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90793);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89009);
/* harmony import */ var react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _src_components_molecules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53732);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54176);
/* harmony import */ var _components_web_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52460);
/* harmony import */ var _components_web_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67099);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2962);
/* harmony import */ var _components_web_SideMenu__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92063);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9465);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60651);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);



















var isServer = false;
var WOW = !isServer ? __webpack_require__(28630) : null;

var Landing = function Landing(props) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB8, _process$env$NEXT_PUB9, _process$env$NEXT_PUB10, _process$env$NEXT_PUB11, _process$env$NEXT_PUB12, _process$env$NEXT_PUB13, _process$env$NEXT_PUB14, _process$env$NEXT_PUB15, _process$env$NEXT_PUB16, _process$env$NEXT_PUB17, _process$env$NEXT_PUB18, _process$env$NEXT_PUB19, _process$env$NEXT_PUB20, _process$env$NEXT_PUB21, _process$env$NEXT_PUB32, _process$env$NEXT_PUB33, _process$env$NEXT_PUB34, _process$env$NEXT_PUB35, _process$env$NEXT_PUB36, _process$env$NEXT_PUB37, _process$env$NEXT_PUB38, _process$env$NEXT_PUB39, _process$env$NEXT_PUB40, _process$env$NEXT_PUB41, _process$env$NEXT_PUB42, _process$env$NEXT_PUB48, _process$env$NEXT_PUB49, _process$env$NEXT_PUB50, _process$env$NEXT_PUB51, _process$env$NEXT_PUB52, _process$env$NEXT_PUB53, _process$env$NEXT_PUB54, _process$env$NEXT_PUB55, _process$env$NEXT_PUB56, _process$env$NEXT_PUB57, _process$env$NEXT_PUB58, _process$env$NEXT_PUB59, _process$env$NEXT_PUB60, _process$env$NEXT_PUB61, _process$env$NEXT_PUB62, _process$env$NEXT_PUB63, _process$env$NEXT_PUB64, _process$env$NEXT_PUB65, _process$env$NEXT_PUB66, _process$env$NEXT_PUB67, _process$env$NEXT_PUB68, _process$env$NEXT_PUB69, _process$env$NEXT_PUB70, _process$env$NEXT_PUB71, _process$env$NEXT_PUB72, _process$env$NEXT_PUB73, _process$env$NEXT_PUB74, _process$env$NEXT_PUB75, _process$env$NEXT_PUB87, _process$env$NEXT_PUB88, _process$env$NEXT_PUB89, _process$env$NEXT_PUB90, _process$env$NEXT_PUB91, _process$env$NEXT_PUB92, _process$env$NEXT_PUB93, _process$env$NEXT_PUB94, _process$env$NEXT_PUB95, _process$env$NEXT_PUB96, _process$env$NEXT_PUB97, _process$env$NEXT_PUB98, _process$env$NEXT_PUB99, _process$env$NEXT_PUB100, _process$env$NEXT_PUB101, _process$env$NEXT_PUB102, _process$env$NEXT_PUB103, _process$env$NEXT_PUB104, _process$env$NEXT_PUB105, _process$env$NEXT_PUB106, _process$env$NEXT_PUB107, _process$env$NEXT_PUB108, _process$env$NEXT_PUB109, _process$env$NEXT_PUB110, _process$env$NEXT_PUB111, _process$env$NEXT_PUB112, _process$env$NEXT_PUB113, _process$env$NEXT_PUB114, _process$env$NEXT_PUB115, _process$env$NEXT_PUB116, _process$env$NEXT_PUB117, _process$env$NEXT_PUB118, _process$env$NEXT_PUB119, _process$env$NEXT_PUB120, _process$env$NEXT_PUB121, _process$env$NEXT_PUB122, _process$env$NEXT_PUB123, _process$env$NEXT_PUB124, _process$env$NEXT_PUB125, _process$env$NEXT_PUB126, _process$env$NEXT_PUB127, _process$env$NEXT_PUB128, _process$env$NEXT_PUB129, _process$env$NEXT_PUB130, _process$env$NEXT_PUB131, _process$env$NEXT_PUB132, _process$env$NEXT_PUB133, _process$env$NEXT_PUB134, _process$env$NEXT_PUB135, _process$env$NEXT_PUB136, _process$env$NEXT_PUB137, _process$env$NEXT_PUB138, _process$env$NEXT_PUB139, _process$env$NEXT_PUB140, _process$env$NEXT_PUB141, _process$env$NEXT_PUB142, _process$env$NEXT_PUB143, _process$env$NEXT_PUB144, _process$env$NEXT_PUB145, _process$env$NEXT_PUB146, _process$env$NEXT_PUB147, _process$env$NEXT_PUB148, _process$env$NEXT_PUB149, _process$env$NEXT_PUB150, _process$env$NEXT_PUB151, _process$env$NEXT_PUB152, _process$env$NEXT_PUB153, _process$env$NEXT_PUB154, _process$env$NEXT_PUB155, _process$env$NEXT_PUB156, _process$env$NEXT_PUB157, _process$env$NEXT_PUB158, _process$env$NEXT_PUB159;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
  var backgroundImage = props.backgroundImage,
      backgroundImageMobile = props.backgroundImageMobile;
  var flatListFestivalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageFestival = 0;
  var flatListEventRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageEvent = 0;
  var flatListArtistRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageArtist = 0;
  var flatListVenueRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageVenue = 0;
  var flatListRooftopRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageRooftop = 0;
  var flatListSpaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageSpa = 0;
  var flatListVenueBeachfulRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageVenueBeachful = 0;
  var flatListPrefabCompanyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pagePrefabCompany = 0;
  var flatListPrefabHomeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pagePrefabHome = 0;
  var flatListZooRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageZoo = 0;
  var flatListAnimalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageAnimal = 0;
  var flatListParkfulRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageParkful = 0;
  var flatListCasinoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageCasino = 0;
  var flatListCastleRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageCastle = 0;
  var flatListResortRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageResort = 0;
  var flatListAparthotelRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageAparthotel = 0;
  var flatListVenueCocktailRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var pageVenueCocktail = 0;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      showTagline = _useState[0],
      setShowTagline = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      sideMenuShow = _useState2[0],
      setSideMenuShow = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      sideMenuHeaderShow = _useState3[0],
      setSideMenuHeaderShow = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      keyword = _useState4[0],
      setKeyword = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      festivalList = _useState5[0],
      setFestivalList = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_POPULARITY */ .gT.sortByAction.SORT_BY_POPULARITY),
      festivalSort = _useState6[0],
      setFestivalSort = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingFestival = _useState7[0],
      setIsLoadingFestival = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      eventList = _useState8[0],
      setEventList = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_POPULARITY */ .gT.sortByAction.SORT_BY_POPULARITY),
      eventSort = _useState9[0],
      setEventSort = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingEvent = _useState10[0],
      setIsLoadingEvent = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      artistList = _useState11[0],
      setArtistList = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_POPULARITY */ .gT.sortByAction.SORT_BY_POPULARITY),
      artistSort = _useState12[0],
      setArtistSort = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingArtist = _useState13[0],
      setIsLoadingArtist = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      venueList = _useState14[0],
      setVenueList = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      venueSort = _useState15[0],
      setVenueSort = _useState15[1];

  var _useState16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingVenue = _useState16[0],
      setIsLoadingVenue = _useState16[1];

  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      rooftopList = _useState17[0],
      setRooftopList = _useState17[1];

  var _useState18 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      rooftopSort = _useState18[0],
      setRooftopSort = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingRooftop = _useState19[0],
      setIsLoadingRooftop = _useState19[1];

  var _useState20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      spaList = _useState20[0],
      setSpaList = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      spaSort = _useState21[0],
      setSpaSort = _useState21[1];

  var _useState22 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingSpa = _useState22[0],
      setIsLoadingSpa = _useState22[1];

  var _useState23 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      venueBeachfulList = _useState23[0],
      setVenueBeachfulList = _useState23[1];

  var _useState24 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      venueBeachfulSort = _useState24[0],
      setVenueBeachfulSort = _useState24[1];

  var _useState25 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingVenueBeachful = _useState25[0],
      setIsLoadingVenueBeachful = _useState25[1];

  var _useState26 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      prefabCompanyList = _useState26[0],
      setPrefabCompanyList = _useState26[1];

  var _useState27 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      prefabCompanySort = _useState27[0],
      setPrefabCompanySort = _useState27[1];

  var _useState28 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingPrefabCompany = _useState28[0],
      setIsLoadingPrefabCompany = _useState28[1];

  var _useState29 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      prefabHomeList = _useState29[0],
      setPrefabHomeList = _useState29[1];

  var _useState30 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      prefabHomeSort = _useState30[0],
      setPrefabHomeSort = _useState30[1];

  var _useState31 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingPrefabHome = _useState31[0],
      setIsLoadingPrefabHome = _useState31[1];

  var _useState32 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      zooList = _useState32[0],
      setZooList = _useState32[1];

  var _useState33 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      zooSort = _useState33[0],
      setZooSort = _useState33[1];

  var _useState34 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingZoo = _useState34[0],
      setIsLoadingZoo = _useState34[1];

  var _useState35 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      animalList = _useState35[0],
      setAnimalList = _useState35[1];

  var _useState36 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      animalSort = _useState36[0],
      setAnimalSort = _useState36[1];

  var _useState37 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingAnimal = _useState37[0],
      setIsLoadingAnimal = _useState37[1];

  var _useState38 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      parkfulList = _useState38[0],
      setParkfulList = _useState38[1];

  var _useState39 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      parkfulSort = _useState39[0],
      setParkfulSort = _useState39[1];

  var _useState40 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingParkful = _useState40[0],
      setIsLoadingParkful = _useState40[1];

  var _useState41 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      casinoList = _useState41[0],
      setCasinoList = _useState41[1];

  var _useState42 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      casinoSort = _useState42[0],
      setCasinoSort = _useState42[1];

  var _useState43 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingCasino = _useState43[0],
      setIsLoadingCasino = _useState43[1];

  var _useState44 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      castleList = _useState44[0],
      setCastleList = _useState44[1];

  var _useState45 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      castleSort = _useState45[0],
      setCastleSort = _useState45[1];

  var _useState46 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingCastle = _useState46[0],
      setIsLoadingCastle = _useState46[1];

  var _useState47 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      resortList = _useState47[0],
      setResortList = _useState47[1];

  var _useState48 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      resortSort = _useState48[0],
      setResortSort = _useState48[1];

  var _useState49 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingResort = _useState49[0],
      setIsLoadingResort = _useState49[1];

  var _useState50 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      aparthotelList = _useState50[0],
      setAparthotelList = _useState50[1];

  var _useState51 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      aparthotelSort = _useState51[0],
      setAparthotelSort = _useState51[1];

  var _useState52 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingAparthotel = _useState52[0],
      setIsLoadingAparthotel = _useState52[1];

  var _useState53 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      venueCocktailList = _useState53[0],
      setVenueCocktailList = _useState53[1];

  var _useState54 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_RECOMMENDED */ .gT.sortByAction.SORT_BY_RECOMMENDED),
      venueCocktailSort = _useState54[0],
      setVenueCocktailSort = _useState54[1];

  var _useState55 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadingVenueCocktail = _useState55[0],
      setIsLoadingVenueCocktail = _useState55[1];

  var _useState56 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      festivalCount = _useState56[0],
      setFestivalCount = _useState56[1];

  var _useState57 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      eventCount = _useState57[0],
      setEventCount = _useState57[1];

  var _useState58 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      artistCount = _useState58[0],
      setArtistCount = _useState58[1];

  var _useState59 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      venueCount = _useState59[0],
      setVenueCount = _useState59[1];

  var _useState60 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      rooftopCount = _useState60[0],
      setRooftopCount = _useState60[1];

  var _useState61 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      spaCount = _useState61[0],
      setSpaCount = _useState61[1];

  var _useState62 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      venueBeachfulCount = _useState62[0],
      setVenueBeachfulCount = _useState62[1];

  var _useState63 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      prefabCompanyCount = _useState63[0],
      setPrefabCompanyCount = _useState63[1];

  var _useState64 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      prefabHomeCount = _useState64[0],
      setPrefabHomeCount = _useState64[1];

  var _useState65 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      zooCount = _useState65[0],
      setZooCount = _useState65[1];

  var _useState66 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      animalCount = _useState66[0],
      setAnimalCount = _useState66[1];

  var _useState67 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      parkfulCount = _useState67[0],
      setParkfulCount = _useState67[1];

  var _useState68 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      casinoCount = _useState68[0],
      setCasinoCount = _useState68[1];

  var _useState69 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      castleCount = _useState69[0],
      setCastleCount = _useState69[1];

  var _useState70 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      resortCount = _useState70[0],
      setResortCount = _useState70[1];

  var _useState71 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      aparthotelCount = _useState71[0],
      setAparthotelCount = _useState71[1];

  var _useState72 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"),
      venueCocktailCount = _useState72[0],
      setVenueCocktailCount = _useState72[1];

  var loadFestival = function loadFestival() {
    setIsLoadingFestival(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("festival_total")) {} else {
      setFestivalCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("festival_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .FestivalDao.findWeb */ .vB.findWeb({
      pageSize: 1
    }).then(function (result) {
      setFestivalCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("festival_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .FestivalDao.findWeb */ .vB.findWeb(festivalSort === _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_TRENDING */ .gT.sortByAction.SORT_BY_TRENDING ? {
      sortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_TRENDING */ .gT.sortByAction.SORT_BY_TRENDING,
      pageSize: 15,
      dateSortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.dateFilterType.DATE_FILTER_UPCOMING */ .gT.dateFilterType.DATE_FILTER_UPCOMING,
      startDateFrom: moment__WEBPACK_IMPORTED_MODULE_12___default()().format("YYYY-MM-DD"),
      startDateTo: moment__WEBPACK_IMPORTED_MODULE_12___default()().add(1, "month").format("YYYY-MM-DD")
    } : {
      sortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_POPULARITY */ .gT.sortByAction.SORT_BY_POPULARITY,
      pageSize: 15,
      dateSortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.dateFilterType.DATE_FILTER_UPCOMING */ .gT.dateFilterType.DATE_FILTER_UPCOMING
    }).then(function (result) {
      setIsLoadingFestival(false);
      setFestivalList(result.data);
    });
  };

  var loadEvent = function loadEvent() {
    setIsLoadingEvent(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("festival_total")) {} else {
      setEventCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("festival_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .EventDao.findWeb */ .SA.findWeb({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT
    }).then(function (result) {
      setEventCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("event_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .EventDao.findWeb */ .SA.findWeb(eventSort === _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_TRENDING */ .gT.sortByAction.SORT_BY_TRENDING ? {
      sortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_TRENDING */ .gT.sortByAction.SORT_BY_TRENDING,
      pageSize: 15,
      dateSortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.dateFilterType.DATE_FILTER_UPCOMING */ .gT.dateFilterType.DATE_FILTER_UPCOMING,
      startDateFrom: moment__WEBPACK_IMPORTED_MODULE_12___default()().format("YYYY-MM-DD"),
      startDateTo: moment__WEBPACK_IMPORTED_MODULE_12___default()().add(1, "month").format("YYYY-MM-DD"),
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT
    } : {
      sortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_POPULARITY */ .gT.sortByAction.SORT_BY_POPULARITY,
      pageSize: 15,
      dateSortType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.dateFilterType.DATE_FILTER_UPCOMING */ .gT.dateFilterType.DATE_FILTER_UPCOMING,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT
    }).then(function (result) {
      setIsLoadingEvent(false);
      setEventList(result.data);
    });
  };

  var loadArtist = function loadArtist() {
    setIsLoadingArtist(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("artist_total")) {
      setArtistCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("artist_total"));
    }

    var params = {
      sortType: artistSort,
      pageSize: 15
    };

    if (artistSort == _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.sortByAction.SORT_BY_TRENDING */ .gT.sortByAction.SORT_BY_TRENDING) {
      params.startDateFrom = moment__WEBPACK_IMPORTED_MODULE_12___default()().format("YYYY-MM-DD");
      params.startDateTo = moment__WEBPACK_IMPORTED_MODULE_12___default()().add(1, "month").format("YYYY-MM-DD");
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .ArtistDao.findWeb */ .uf.findWeb({
      pageSize: 1
    }).then(function (result) {
      setArtistCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("artist_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .ArtistDao.findWeb */ .uf.findWeb(params).then(function (result) {
      setIsLoadingArtist(false);
      setArtistList(result.data);
    });
  };

  var loadVenue = function loadVenue() {
    setIsLoadingVenue(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_total")) {} else {
      setVenueCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1
    }).then(function (result) {
      setVenueCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("venue_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: venueSort,
      pageSize: 15,
      venueStatus: [_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED]
    }).then(function (result) {
      setIsLoadingVenue(false);
      setVenueList(result.data);
    });
  };

  var loadRooftop = function loadRooftop() {
    setIsLoadingRooftop(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("rooftop_total")) {} else {
      setRooftopCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("rooftop_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP
    }).then(function (result) {
      setRooftopCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("rooftop_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: rooftopSort,
      pageSize: 15,
      venueStatus: [_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP
    }).then(function (result) {
      setIsLoadingRooftop(false);
      setRooftopList(result.data);
    });
  };

  var loadSpa = function loadSpa() {
    setIsLoadingSpa(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("spa_total")) {} else {
      setSpaCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("spa_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA
    }).then(function (result) {
      setSpaCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("spa_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: spaSort,
      pageSize: 15,
      venueStatus: [_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA
    }).then(function (result) {
      setIsLoadingSpa(false);
      setSpaList(result.data);
    });
  };

  var loadVenueBeachful = function loadVenueBeachful() {
    setIsLoadingVenueBeachful(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_beachful_total")) {} else {
      setVenueBeachfulCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_beachful_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL
    }).then(function (result) {
      setVenueBeachfulCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("venue_beachful_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: venueBeachfulSort,
      pageSize: 15,
      venueStatus: [_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL
    }).then(function (result) {
      setIsLoadingVenueBeachful(false);
      setVenueBeachfulList(result.data);
    });
  };

  var loadPrefabCompany = function loadPrefabCompany() {
    setIsLoadingPrefabCompany(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("prefab_company_total")) {} else {
      setPrefabCompanyCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("prefab_company_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY
    }).then(function (result) {
      setPrefabCompanyCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("prefab_company_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: prefabCompanySort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY
    }).then(function (result) {
      setIsLoadingPrefabCompany(false);
      setPrefabCompanyList(result.data);
    });
  };

  var loadPrefabHome = function loadPrefabHome() {
    setIsLoadingPrefabHome(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("prefab_home_total")) {} else {
      setPrefabHomeCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("prefab_home_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES
    }).then(function (result) {
      setPrefabHomeCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("prefab_home_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: prefabHomeSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES
    }).then(function (result) {
      setIsLoadingPrefabHome(false);
      setPrefabHomeList(result.data);
    });
  };

  var loadZoo = function loadZoo() {
    setIsLoadingZoo(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("zoo_total")) {} else {
      setZooCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("zoo_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO
    }).then(function (result) {
      setZooCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("zoo_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: zooSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO
    }).then(function (result) {
      setIsLoadingZoo(false);
      setZooList(result.data);
    });
  };

  var loadAnimal = function loadAnimal() {
    setIsLoadingAnimal(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("animal_total")) {} else {
      setAnimalCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("animal_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL
    }).then(function (result) {
      setAnimalCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("animal_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: animalSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL
    }).then(function (result) {
      setIsLoadingAnimal(false);
      setAnimalList(result.data);
    });
  };

  var loadParkful = function loadParkful() {
    setIsLoadingParkful(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("parkful_total")) {} else {
      setParkfulCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("parkful_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL
    }).then(function (result) {
      setParkfulCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("parkful_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: parkfulSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL
    }).then(function (result) {
      setIsLoadingParkful(false);
      setParkfulList(result.data);
    });
  };

  var loadCasino = function loadCasino() {
    setIsLoadingCasino(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("casino_total")) {} else {
      setCasinoCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("casino_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO
    }).then(function (result) {
      setCasinoCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("casino_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: casinoSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO
    }).then(function (result) {
      setIsLoadingCasino(false);
      setCasinoList(result.data);
    });
  };

  var loadCastle = function loadCastle() {
    setIsLoadingCastle(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("castle_total")) {} else {
      setCastleCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("castle_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE
    }).then(function (result) {
      setCastleCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("castle_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: castleSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE
    }).then(function (result) {
      setIsLoadingCastle(false);
      setCastleList(result.data);
    });
  };

  var loadResort = function loadResort() {
    setIsLoadingResort(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("resort_total")) {} else {
      setResortCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("resort_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT
    }).then(function (result) {
      setResortCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("resort_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: resortSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT
    }).then(function (result) {
      setIsLoadingResort(false);
      setResortList(result.data);
    });
  };

  var loadAparthotel = function loadAparthotel() {
    setIsLoadingAparthotel(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("aparthotel_total")) {} else {
      setAparthotelCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("aparthotel_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL
    }).then(function (result) {
      setAparthotelCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("aparthotel_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: aparthotelSort,
      pageSize: 15,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL
    }).then(function (result) {
      setIsLoadingAparthotel(false);
      setAparthotelList(result.data);
    });
  };

  var loadVenueCocktail = function loadVenueCocktail() {
    setIsLoadingVenueCocktail(true);

    if ((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_cocktail_total")) {} else {
      setVenueCocktailCount((0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.getCookie)("venue_cocktail_total"));
    }

    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      pageSize: 1,
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL
    }).then(function (result) {
      setVenueCocktailCount("+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)));
      (0,cookies_next__WEBPACK_IMPORTED_MODULE_2__.setCookies)("venue_cocktail_total", "+".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .nFormatter */ .pF)(result.totalCount)), {
        maxAge: 86400000
      }); //expired 1 day in milliseconds
    });
    _src_DAO__WEBPACK_IMPORTED_MODULE_0__/* .VenueDao.find */ .eL.find({
      sortType: venueCocktailSort,
      pageSize: 15,
      venueStatus: [_src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE, _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED */ .gT.venueStatus.FE_STAT_TEMPORARILY_CLOSED],
      categoryType: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL
    }).then(function (result) {
      setIsLoadingVenueCocktail(false);
      setVenueCocktailList(result.data);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Festivals";
    })) {
      loadFestival();
    }
  }, [festivalSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Artists";
    })) {
      loadArtist();
    }
  }, [artistSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Venues";
    })) {
      loadVenue();
    }
  }, [venueSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Rooftops";
    })) {
      loadRooftop();
    }
  }, [rooftopSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Spas";
    })) {
      loadSpa();
    }
  }, [spaSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Venue Beachful";
    })) {
      loadVenueBeachful();
    }
  }, [venueBeachfulSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Prefab Company";
    })) {
      loadPrefabCompany();
    }
  }, [prefabCompanySort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Prefab Home";
    })) {
      loadPrefabHome();
    }
  }, [prefabHomeSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Zoos";
    })) {
      loadZoo();
    }
  }, [zooSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Animals";
    })) {
      loadAnimal();
    }
  }, [animalSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Parks";
    })) {
      loadParkful();
    }
  }, [parkfulSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Casinos";
    })) {
      loadCasino();
    }
  }, [casinoSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Castles";
    })) {
      loadCastle();
    }
  }, [castleSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Resorts";
    })) {
      loadResort();
    }
  }, [resortSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Aparthotels";
    })) {
      loadAparthotel();
    }
  }, [aparthotelSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Venue Cocktail";
    })) {
      loadVenueCocktail();
    }
  }, [venueCocktailSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if ("Venues".split(",").find(function (i) {
      return i === "Events";
    })) {
      loadEvent();
    }
  }, [eventSort]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    new WOW().init();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setTimeout(function () {
      setShowTagline(false);
    }, 2000);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
    className: "sm:h-auto sm:block flex flex-col h-screen overflow-hidden",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_9__/* .NextSeo */ .PB, {
      title: "".concat("Vybeful").concat(" - The Vibe You Need"),
      description: "Discover amazing clubs and other live music venues around the world | Join us now.",
      canonical: "https://".concat("www.vybeful.com"),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.vybeful.com"),
        title: "".concat("Vybeful").concat(" - The Vibe You Need"),
        description: "Discover amazing clubs and other live music venues around the world | Join us now.",
        images: [{
          url: "https://".concat("www.vybeful.com").concat("/images/og-vybeful.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Vybeful").concat(" - The Vibe You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Vybeful").concat(" - The Vibe You Need")
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_web_Header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_web_SideMenu__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      id: "home",
      style: {
        // backgroundImage: "url(/images/landing_bg_mobile.jpg)",
        backgroundImage: "url(".concat(backgroundImageMobile, ")"),
        backgroundSize: "cover",
        backgroundPosition: "bottom center",
        backgroundColor: "black"
      },
      className: "sm:hidden block sm:h-auto flex flex-1",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        className: "w-full h-full flex flex-1 ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black6", true)),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
          className: "wrapper sm:block flex flex-col justify-between mx-auto relative md:h-800px md:py-0 sm:py-20 py-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "flex flex-col justify-center items-center flex-1",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("h1", {
              className: "hidden",
              children: ["Vybeful", (_process$env$NEXT_PUB = " - The Vibe You Need") === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.replace(" - ", "")]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
              "data-wow-delay": "1.5s",
              "data-wow-iteration": "1",
              className: "wow fadeOut sm:h-45px h-29px flex flex-row flex-wrap items-center justify-center md:text-40px text-2xl font-bold text-white text-center sm:mb-146px mb-0 ".concat(showTagline ? "" : "opacity-0"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "wow fadeInDown",
                children: (_process$env$NEXT_PUB2 = " - The Vibe You Need") === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.replace(" - ", "")
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "flex flex-col items-center sm:h-full sm:pb-73px mb-0 md:pt-128px sm:pt-20 pt-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-grayBackground3", true), " rounded-full sm:flex hidden flex-row items-center justify-between h-50px md:w-670px w-full mb-98px"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " h-50px w-100px -mr-1 rounded-full cursor-pointer"),
                  onClick: function onClick() {
                    var _process$env$NEXT_PUB3, _process$env$NEXT_PUB4, _process$env$NEXT_PUB5, _process$env$NEXT_PUB6, _process$env$NEXT_PUB7;

                    return router.push("/explore/".concat((_process$env$NEXT_PUB3 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.toLowerCase()) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : (_process$env$NEXT_PUB5 = _process$env$NEXT_PUB4.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB5 === void 0 ? void 0 : (_process$env$NEXT_PUB6 = _process$env$NEXT_PUB5.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB6 === void 0 ? void 0 : (_process$env$NEXT_PUB7 = _process$env$NEXT_PUB6.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB7 === void 0 ? void 0 : _process$env$NEXT_PUB7.replace("prefab home", "homes"), "?search=").concat(keyword));
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                    src: "/icons/ic_search.svg",
                    alt: "search"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                  className: "bg-transparent font-regular md:text-lg text-sm ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " ").concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("placeholder-input"), " md:ml-8 ml-4 outline-0 w-400px"),
                  placeholder: (_process$env$NEXT_PUB8 = "Venues".split(",").join(" | ")) === null || _process$env$NEXT_PUB8 === void 0 ? void 0 : (_process$env$NEXT_PUB9 = _process$env$NEXT_PUB8.replace("Festivals", "Festival")) === null || _process$env$NEXT_PUB9 === void 0 ? void 0 : (_process$env$NEXT_PUB10 = _process$env$NEXT_PUB9.replace("Artists", "Artist")) === null || _process$env$NEXT_PUB10 === void 0 ? void 0 : (_process$env$NEXT_PUB11 = _process$env$NEXT_PUB10.replace("Venues", "Venue")) === null || _process$env$NEXT_PUB11 === void 0 ? void 0 : (_process$env$NEXT_PUB12 = _process$env$NEXT_PUB11.replace("Rooftops", "Rooftop")) === null || _process$env$NEXT_PUB12 === void 0 ? void 0 : (_process$env$NEXT_PUB13 = _process$env$NEXT_PUB12.replace("Spas", "Spa")) === null || _process$env$NEXT_PUB13 === void 0 ? void 0 : (_process$env$NEXT_PUB14 = _process$env$NEXT_PUB13.replace("Venue Cocktail", "Bar")) === null || _process$env$NEXT_PUB14 === void 0 ? void 0 : (_process$env$NEXT_PUB15 = _process$env$NEXT_PUB14.replace("Venue Beachful", "Beach Club")) === null || _process$env$NEXT_PUB15 === void 0 ? void 0 : (_process$env$NEXT_PUB16 = _process$env$NEXT_PUB15.replace("Prefab Company", "Company")) === null || _process$env$NEXT_PUB16 === void 0 ? void 0 : (_process$env$NEXT_PUB17 = _process$env$NEXT_PUB16.replace("Prefab Home", "Home")) === null || _process$env$NEXT_PUB17 === void 0 ? void 0 : (_process$env$NEXT_PUB18 = _process$env$NEXT_PUB17.replace("Parks", "Park")) === null || _process$env$NEXT_PUB18 === void 0 ? void 0 : (_process$env$NEXT_PUB19 = _process$env$NEXT_PUB18.replace("Casinos", "Casino")) === null || _process$env$NEXT_PUB19 === void 0 ? void 0 : (_process$env$NEXT_PUB20 = _process$env$NEXT_PUB19.replace("Castles", "Castle")) === null || _process$env$NEXT_PUB20 === void 0 ? void 0 : (_process$env$NEXT_PUB21 = _process$env$NEXT_PUB20.replace("Resorts", "Resort")) === null || _process$env$NEXT_PUB21 === void 0 ? void 0 : _process$env$NEXT_PUB21.replace("Aparthotels", "Aparthotel"),
                  onChange: function onChange(e) {
                    return setKeyword(e.target.value);
                  },
                  value: keyword,
                  onKeyDown: function onKeyDown(e) {
                    var _process$env$NEXT_PUB22, _process$env$NEXT_PUB23, _process$env$NEXT_PUB24, _process$env$NEXT_PUB25, _process$env$NEXT_PUB26;

                    return e.key === "Enter" ? router.push("/explore/".concat((_process$env$NEXT_PUB22 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB22 === void 0 ? void 0 : (_process$env$NEXT_PUB23 = _process$env$NEXT_PUB22.toLowerCase()) === null || _process$env$NEXT_PUB23 === void 0 ? void 0 : (_process$env$NEXT_PUB24 = _process$env$NEXT_PUB23.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB24 === void 0 ? void 0 : (_process$env$NEXT_PUB25 = _process$env$NEXT_PUB24.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB25 === void 0 ? void 0 : (_process$env$NEXT_PUB26 = _process$env$NEXT_PUB25.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB26 === void 0 ? void 0 : _process$env$NEXT_PUB26.replace("prefab home", "homes"), "?search=").concat(keyword)) : null;
                  }
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " h-50px -mr-1 w-100px w-full rounded-full cursor-pointer"),
                onClick: function onClick() {
                  var _process$env$NEXT_PUB27, _process$env$NEXT_PUB28, _process$env$NEXT_PUB29, _process$env$NEXT_PUB30, _process$env$NEXT_PUB31;

                  return router.push("/explore/".concat((_process$env$NEXT_PUB27 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB27 === void 0 ? void 0 : (_process$env$NEXT_PUB28 = _process$env$NEXT_PUB27.toLowerCase()) === null || _process$env$NEXT_PUB28 === void 0 ? void 0 : (_process$env$NEXT_PUB29 = _process$env$NEXT_PUB28.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB29 === void 0 ? void 0 : (_process$env$NEXT_PUB30 = _process$env$NEXT_PUB29.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB30 === void 0 ? void 0 : (_process$env$NEXT_PUB31 = _process$env$NEXT_PUB30.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB31 === void 0 ? void 0 : _process$env$NEXT_PUB31.replace("prefab home", "homes")));
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/ic_filter.svg",
                  alt: "filter"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
              href: "/explore/".concat((_process$env$NEXT_PUB32 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB32 === void 0 ? void 0 : (_process$env$NEXT_PUB33 = _process$env$NEXT_PUB32.toLowerCase()) === null || _process$env$NEXT_PUB33 === void 0 ? void 0 : (_process$env$NEXT_PUB34 = _process$env$NEXT_PUB33.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB34 === void 0 ? void 0 : (_process$env$NEXT_PUB35 = _process$env$NEXT_PUB34.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB35 === void 0 ? void 0 : (_process$env$NEXT_PUB36 = _process$env$NEXT_PUB35.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB36 === void 0 ? void 0 : _process$env$NEXT_PUB36.replace("prefab home", "homes")),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                className: "sm:hidden block w-190px sm:mt-80px mt-0 mb-[20px] flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " py-1 px-6 rounded-full cursor-pointer uppercase font-bold text-white"),
                children: "Explore"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
              href: "/guides",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                className: "sm:hidden block w-190px sm:mt-80px mt-0 mb-60px flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " py-1 px-6 rounded-full cursor-pointer uppercase font-bold text-white"),
                children: "Guides"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "relative",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center mb-20px px-3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient1", true), " h-2px rounded-full w-full")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "md:text-2xl text-lg font-bold text-white uppercase text-center mx-4 relative z-5",
                  children: t("key_web_discover")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient1", true), " h-2px rounded-full w-full")
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center",
                children: ["Venues".split(",").find(function (i) {
                  return i === "Venues";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/venues",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( true ? "w-[180px]" : 0, " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_venues")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_venue_web.png",
                          alt: "venue"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_venue_web.png",
                          alt: "venue"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: venueCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Rooftops";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/rooftops",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_rooftops")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/rooftopclub/ic_search_general_web.png",
                          alt: "rooftop"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/rooftopclub/ic_search_general_web.png",
                          alt: "rooftop"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: rooftopCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Spas";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/spas",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-15px mb-3",
                        children: t("key_web_spas")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/spaclub/ic_search_general_web.png",
                          alt: "spas"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/spaclub/ic_search_general_web.png",
                          alt: "spas"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: spaCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Venue Beachful";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/beach-clubs",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_beachclubs")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/beachful/ic_search_general_web.png",
                          alt: "beach clubs"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/beachful/ic_search_general_web.png",
                          alt: "beach clubs"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: venueBeachfulCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Prefab Home";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/homes",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_prefab_home")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "homes"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "homes"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: prefabHomeCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Prefab Company";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/companies",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_prefab_company")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "companies"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "companies"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: prefabCompanyCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Zoos";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/zoos",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "Zoos"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "zoos"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "zoos"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: zooCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Animals";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/animals",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "Animals"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "animals"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "animals"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: animalCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Parks";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/parks",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "PARKS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/parkful/ic_search_general_web.png",
                          alt: "parks"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/parkful/ic_search_general_web.png",
                          alt: "parks"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: parkfulCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Casinos";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/casinos",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "CASINOS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/worldcasino/ic_search_general_web.png",
                          alt: "casinos"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/worldcasino/ic_search_general_web.png",
                          alt: "casinos"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: casinoCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Castles";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/castles",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "CASTLES"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/castlepedia/ic_search_general_web.png",
                          alt: "castles"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/castlepedia/ic_search_general_web.png",
                          alt: "castles"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: castleCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Resorts";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/resorts",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "RESORTS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/luxresortclub/ic_search_general_web.png",
                          alt: "resorts"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/luxresortclub/ic_search_general_web.png",
                          alt: "resorts"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: resortCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Aparthotels";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/aparthotels",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "APARTHOTELS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/aparthotelclub/ic_search_general_web.png",
                          alt: "aparthotels"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/aparthotelclub/ic_search_general_web.png",
                          alt: "aparthotels"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: aparthotelCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Venue Cocktail";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/bars",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px ".concat( false ? 0 : "w-85px", " cursor-pointer"),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-15px mb-3",
                        children: t("key_web_bars")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/cocktayl/ic_search_general_web.png",
                          alt: "bars"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/cocktayl/ic_search_general_web.png",
                          alt: "bars"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: venueCocktailCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Festivals";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/festivals",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-14px mb-3",
                        children: t("key_web_festivals")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_festival_web.png",
                          alt: "festival"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_festival_web.png",
                          alt: "festival"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: festivalCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Events";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/events",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-14px mb-3",
                        children: t("key_web_events")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_event_web.png",
                          alt: "event"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_event_web.png",
                          alt: "event"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: eventCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Artists";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/artists",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-15px mb-3",
                        children: t("key_web_artists")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 21,
                          height: 28,
                          src: "/icons/ic_search_artist_web.png",
                          alt: "artist"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 15,
                          height: 20,
                          src: "/icons/ic_search_artist_web.png",
                          alt: "artist"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: artistCount
                      })
                    })]
                  })
                })]
              })]
            })]
          }),  false && /*#__PURE__*/0,  true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
            className: "flex flex-1 items-end justify-center pb-[14px]",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row items-center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "px-2",
                style: {
                  height: 18
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  href: "https://www.facebook.com/vybefulcom",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                    src: "/icons/ic_facebook_circle.svg",
                    width: 18,
                    height: 18,
                    alt: "facebook"
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "px-2",
                style: {
                  height: 18
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  href: "https://www.instagram.com/vybefulcom",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                    src: "/icons/ic_instagram_circle.svg",
                    width: 19,
                    height: 18,
                    alt: "instagram"
                  })
                })
              })]
            })
          }),  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0,  false && /*#__PURE__*/0]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      id: "home",
      style: {
        backgroundImage: "url(".concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "bottom center"
      },
      className: "sm:block hidden sm:h-auto h-full flex flex-1",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        className: "w-full h-full flex flex-1 ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black6", true)),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
          className: "wrapper sm:block flex flex-col justify-center mx-auto relative md:h-800px md:py-0 sm:py-20 py-0 sm:pt-0 pt-20 sm:pb-0 pb-32",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "flex flex-col items-center sm:h-full sm:pb-73px mb-0 md:pt-128px sm:pt-20 pt-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
              "data-wow-delay": "1.5s",
              "data-wow-iteration": "1",
              className: "wow fadeOut h-45px flex flex-row flex-wrap items-center justify-center md:text-40px text-2xl font-bold text-white text-center sm:mb-146px mb-0 ".concat(showTagline ? "" : "opacity-0"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "wow fadeInDown mr-3",
                children: (_process$env$NEXT_PUB37 = " - The Vibe You Need") === null || _process$env$NEXT_PUB37 === void 0 ? void 0 : _process$env$NEXT_PUB37.replace(" - ", "")
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("form", {
              action: "/explore/".concat((_process$env$NEXT_PUB38 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB38 === void 0 ? void 0 : (_process$env$NEXT_PUB39 = _process$env$NEXT_PUB38.toLowerCase()) === null || _process$env$NEXT_PUB39 === void 0 ? void 0 : (_process$env$NEXT_PUB40 = _process$env$NEXT_PUB39.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB40 === void 0 ? void 0 : (_process$env$NEXT_PUB41 = _process$env$NEXT_PUB40.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB41 === void 0 ? void 0 : (_process$env$NEXT_PUB42 = _process$env$NEXT_PUB41.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB42 === void 0 ? void 0 : _process$env$NEXT_PUB42.replace("prefab home", "homes")),
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-grayBackground3", true), " rounded-full sm:flex hidden flex-row items-center justify-between h-50px md:w-670px w-full mb-98px"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("button", {
                  type: "submit",
                  className: "flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " h-50px w-100px -mr-1 rounded-full cursor-pointer"),
                  onClick: function onClick() {
                    var _process$env$NEXT_PUB43, _process$env$NEXT_PUB44, _process$env$NEXT_PUB45, _process$env$NEXT_PUB46, _process$env$NEXT_PUB47;

                    return router.push("/explore/".concat((_process$env$NEXT_PUB43 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB43 === void 0 ? void 0 : (_process$env$NEXT_PUB44 = _process$env$NEXT_PUB43.toLowerCase()) === null || _process$env$NEXT_PUB44 === void 0 ? void 0 : (_process$env$NEXT_PUB45 = _process$env$NEXT_PUB44.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB45 === void 0 ? void 0 : (_process$env$NEXT_PUB46 = _process$env$NEXT_PUB45.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB46 === void 0 ? void 0 : (_process$env$NEXT_PUB47 = _process$env$NEXT_PUB46.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB47 === void 0 ? void 0 : _process$env$NEXT_PUB47.replace("prefab home", "homes"), "?search=").concat(keyword));
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                    src: "/icons/ic_search.svg",
                    alt: "search"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("input", {
                  name: "search",
                  type: "search",
                  "aria-label": "Search ".concat((_process$env$NEXT_PUB48 = "Venues".split(",").join(" | ")) === null || _process$env$NEXT_PUB48 === void 0 ? void 0 : (_process$env$NEXT_PUB49 = _process$env$NEXT_PUB48.replace("Festivals", "Festival")) === null || _process$env$NEXT_PUB49 === void 0 ? void 0 : (_process$env$NEXT_PUB50 = _process$env$NEXT_PUB49.replace("Artists", "Artist")) === null || _process$env$NEXT_PUB50 === void 0 ? void 0 : (_process$env$NEXT_PUB51 = _process$env$NEXT_PUB50.replace("Venues", "Venue")) === null || _process$env$NEXT_PUB51 === void 0 ? void 0 : (_process$env$NEXT_PUB52 = _process$env$NEXT_PUB51.replace("Rooftops", "Rooftop")) === null || _process$env$NEXT_PUB52 === void 0 ? void 0 : (_process$env$NEXT_PUB53 = _process$env$NEXT_PUB52.replace("Spas", "Spa")) === null || _process$env$NEXT_PUB53 === void 0 ? void 0 : (_process$env$NEXT_PUB54 = _process$env$NEXT_PUB53.replace("Venue Cocktail", "Bar")) === null || _process$env$NEXT_PUB54 === void 0 ? void 0 : (_process$env$NEXT_PUB55 = _process$env$NEXT_PUB54.replace("Venue Beachful", "Beach Club")) === null || _process$env$NEXT_PUB55 === void 0 ? void 0 : (_process$env$NEXT_PUB56 = _process$env$NEXT_PUB55.replace("Prefab Company", "Company")) === null || _process$env$NEXT_PUB56 === void 0 ? void 0 : (_process$env$NEXT_PUB57 = _process$env$NEXT_PUB56.replace("Prefab Home", "Home")) === null || _process$env$NEXT_PUB57 === void 0 ? void 0 : (_process$env$NEXT_PUB58 = _process$env$NEXT_PUB57.replace("Parks", "Park")) === null || _process$env$NEXT_PUB58 === void 0 ? void 0 : (_process$env$NEXT_PUB59 = _process$env$NEXT_PUB58.replace("Casinos", "Casino")) === null || _process$env$NEXT_PUB59 === void 0 ? void 0 : (_process$env$NEXT_PUB60 = _process$env$NEXT_PUB59.replace("Castles", "Castle")) === null || _process$env$NEXT_PUB60 === void 0 ? void 0 : (_process$env$NEXT_PUB61 = _process$env$NEXT_PUB60.replace("Resorts", "Resort")) === null || _process$env$NEXT_PUB61 === void 0 ? void 0 : _process$env$NEXT_PUB61.replace("Aparthotels", "Aparthotel")),
                  className: "bg-transparent font-regular md:text-lg text-sm ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " ").concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("placeholder-input"), " md:ml-8 ml-4 outline-0 w-400px"),
                  placeholder: (_process$env$NEXT_PUB62 = "Venues".split(",").join(" | ")) === null || _process$env$NEXT_PUB62 === void 0 ? void 0 : (_process$env$NEXT_PUB63 = _process$env$NEXT_PUB62.replace("Festivals", "Festival")) === null || _process$env$NEXT_PUB63 === void 0 ? void 0 : (_process$env$NEXT_PUB64 = _process$env$NEXT_PUB63.replace("Artists", "Artist")) === null || _process$env$NEXT_PUB64 === void 0 ? void 0 : (_process$env$NEXT_PUB65 = _process$env$NEXT_PUB64.replace("Venues", "Venue")) === null || _process$env$NEXT_PUB65 === void 0 ? void 0 : (_process$env$NEXT_PUB66 = _process$env$NEXT_PUB65.replace("Rooftops", "Rooftop")) === null || _process$env$NEXT_PUB66 === void 0 ? void 0 : (_process$env$NEXT_PUB67 = _process$env$NEXT_PUB66.replace("Spas", "Spa")) === null || _process$env$NEXT_PUB67 === void 0 ? void 0 : (_process$env$NEXT_PUB68 = _process$env$NEXT_PUB67.replace("Venue Cocktail", "Bar")) === null || _process$env$NEXT_PUB68 === void 0 ? void 0 : (_process$env$NEXT_PUB69 = _process$env$NEXT_PUB68.replace("Venue Beachful", "Beach Club")) === null || _process$env$NEXT_PUB69 === void 0 ? void 0 : (_process$env$NEXT_PUB70 = _process$env$NEXT_PUB69.replace("Prefab Company", "Company")) === null || _process$env$NEXT_PUB70 === void 0 ? void 0 : (_process$env$NEXT_PUB71 = _process$env$NEXT_PUB70.replace("Prefab Home", "Home")) === null || _process$env$NEXT_PUB71 === void 0 ? void 0 : (_process$env$NEXT_PUB72 = _process$env$NEXT_PUB71.replace("Parks", "Park")) === null || _process$env$NEXT_PUB72 === void 0 ? void 0 : (_process$env$NEXT_PUB73 = _process$env$NEXT_PUB72.replace("Casinos", "Casino")) === null || _process$env$NEXT_PUB73 === void 0 ? void 0 : (_process$env$NEXT_PUB74 = _process$env$NEXT_PUB73.replace("Castles", "Castle")) === null || _process$env$NEXT_PUB74 === void 0 ? void 0 : (_process$env$NEXT_PUB75 = _process$env$NEXT_PUB74.replace("Resorts", "Resort")) === null || _process$env$NEXT_PUB75 === void 0 ? void 0 : _process$env$NEXT_PUB75.replace("Aparthotels", "Aparthotel"),
                  onChange: function onChange(e) {
                    return setKeyword(e.target.value);
                  },
                  value: keyword,
                  onKeyDown: function onKeyDown(e) {
                    var _process$env$NEXT_PUB76, _process$env$NEXT_PUB77, _process$env$NEXT_PUB78, _process$env$NEXT_PUB79, _process$env$NEXT_PUB80, _process$env$NEXT_PUB81;

                    return e.key === "Enter" ? router.push("/explore/".concat((_process$env$NEXT_PUB76 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB76 === void 0 ? void 0 : (_process$env$NEXT_PUB77 = _process$env$NEXT_PUB76.toLowerCase()) === null || _process$env$NEXT_PUB77 === void 0 ? void 0 : (_process$env$NEXT_PUB78 = _process$env$NEXT_PUB77.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB78 === void 0 ? void 0 : (_process$env$NEXT_PUB79 = _process$env$NEXT_PUB78.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB79 === void 0 ? void 0 : (_process$env$NEXT_PUB80 = _process$env$NEXT_PUB79.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB80 === void 0 ? void 0 : (_process$env$NEXT_PUB81 = _process$env$NEXT_PUB80.replace("prefab home", "homes")) === null || _process$env$NEXT_PUB81 === void 0 ? void 0 : _process$env$NEXT_PUB81.replace("parkful", "parks"), "?search=").concat(keyword)) : null;
                  }
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " h-50px -mr-1 w-100px w-full rounded-full cursor-pointer"),
                onClick: function onClick() {
                  var _process$env$NEXT_PUB82, _process$env$NEXT_PUB83, _process$env$NEXT_PUB84, _process$env$NEXT_PUB85, _process$env$NEXT_PUB86;

                  return router.push("/explore/".concat((_process$env$NEXT_PUB82 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB82 === void 0 ? void 0 : (_process$env$NEXT_PUB83 = _process$env$NEXT_PUB82.toLowerCase()) === null || _process$env$NEXT_PUB83 === void 0 ? void 0 : (_process$env$NEXT_PUB84 = _process$env$NEXT_PUB83.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB84 === void 0 ? void 0 : (_process$env$NEXT_PUB85 = _process$env$NEXT_PUB84.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB85 === void 0 ? void 0 : (_process$env$NEXT_PUB86 = _process$env$NEXT_PUB85.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB86 === void 0 ? void 0 : _process$env$NEXT_PUB86.replace("prefab home", "homes")));
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/ic_filter.svg",
                  alt: "filter"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
              href: "/explore/".concat((_process$env$NEXT_PUB87 = "Venues".split(",")[0]) === null || _process$env$NEXT_PUB87 === void 0 ? void 0 : (_process$env$NEXT_PUB88 = _process$env$NEXT_PUB87.toLowerCase()) === null || _process$env$NEXT_PUB88 === void 0 ? void 0 : (_process$env$NEXT_PUB89 = _process$env$NEXT_PUB88.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB89 === void 0 ? void 0 : (_process$env$NEXT_PUB90 = _process$env$NEXT_PUB89.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB90 === void 0 ? void 0 : (_process$env$NEXT_PUB91 = _process$env$NEXT_PUB90.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB91 === void 0 ? void 0 : _process$env$NEXT_PUB91.replace("prefab home", "homes")),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                className: "sm:hidden block w-190px sm:mt-80px mt-0 mb-[20px] flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " py-1 px-6 rounded-full cursor-pointer uppercase font-bold text-white"),
                children: "Explore"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
              href: "/guides",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                className: "sm:hidden block w-190px sm:mt-80px mt-0 mb-60px flex flex-row justify-center items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("btn-gradient"), " py-1 px-6 rounded-full cursor-pointer uppercase font-bold text-white"),
                children: "Guides"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "relative",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center mb-20px px-3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient1", true), " h-2px rounded-full w-full")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "md:text-2xl text-lg font-bold text-white uppercase text-center mx-9 relative z-5",
                  children: t("key_web_discover")
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient1", true), " h-2px rounded-full w-full")
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                className: "flex flex-row items-center",
                children: ["Venues".split(",").find(function (i) {
                  return i === "Venues";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/venues",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_venues")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_venue_web.png",
                          alt: "venue"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_venue_web.png",
                          alt: "venue"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: venueCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Rooftops";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/rooftops",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_rooftops")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/rooftopclub/ic_search_general_web.png",
                          alt: "rooftop"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/rooftopclub/ic_search_general_web.png",
                          alt: "rooftop"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: rooftopCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Spas";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/spas",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_spas")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/spaclub/ic_search_general_web.png",
                          alt: "spas"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/spaclub/ic_search_general_web.png",
                          alt: "spas"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: spaCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Venue Beachful";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/beach-clubs",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_beachclubs")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/beachful/ic_search_general_web.png",
                          alt: "beach clubs"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/beachful/ic_search_general_web.png",
                          alt: "beach clubs"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: venueBeachfulCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Prefab Home";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/homes",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_prefab_home")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "homes"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "homes"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: prefabHomeCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Prefab Company";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/companies",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: t("key_web_prefab_company")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "companies"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/prefabworld/ic_search_general_web.png",
                          alt: "companies"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: prefabCompanyCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Zoos";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/zoos",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "Zoos"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "zoos"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "zoos"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: zooCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Animals";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/animals",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "Animals"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "animals"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/zoopedia/ic_search_general_web.png",
                          alt: "animals"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: animalCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Parks";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/parks",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "PARKS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/parkful/ic_search_general_web.png",
                          alt: "parks"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/parkful/ic_search_general_web.png",
                          alt: "parks"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: parkfulCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Casinos";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/casinos",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "CASINOS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/worldcasino/ic_search_general_web.png",
                          alt: "casinos"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/worldcasino/ic_search_general_web.png",
                          alt: "casinos"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: casinoCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Castles";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/castles",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "CASTLES"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/castlepedia/ic_search_general_web.png",
                          alt: "castles"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/castlepedia/ic_search_general_web.png",
                          alt: "castles"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: castleCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Resorts";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/resorts",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "RESORTS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/luxresortclub/ic_search_general_web.png",
                          alt: "resorts"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/luxresortclub/ic_search_general_web.png",
                          alt: "resorts"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: resortCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Aparthotels";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/aparthotels",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-gradient-black"), " sm:h-120px h-79px sm:pt-6 pt-4 sm:px-0 px-0 rounded-t-lg"),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase text-center sm:mb-15px mb-3"),
                        children: "APARTHOTELS"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/aparthotelclub/ic_search_general_web.png",
                          alt: "aparthotels"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/aparthotelclub/ic_search_general_web.png",
                          alt: "aparthotels"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black4", true), " flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg"),
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " text-center"),
                        children: aparthotelCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Venue Cocktail";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/bars",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-15px mb-3",
                        children: t("key_web_bars")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 36,
                          height: 36,
                          src: "/icons/cocktayl/ic_search_general_web.png",
                          alt: "bars"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/cocktayl/ic_search_general_web.png",
                          alt: "bars"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: venueCocktailCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Festivals";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/festivals",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-14px mb-3",
                        children: t("key_web_festivals")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_festival_web.png",
                          alt: "festival"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_festival_web.png",
                          alt: "festival"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: festivalCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Events";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/events",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-14px mb-3",
                        children: t("key_web_events")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 28,
                          height: 28,
                          src: "/icons/ic_search_event_web.png",
                          alt: "event"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 20,
                          height: 20,
                          src: "/icons/ic_search_event_web.png",
                          alt: "event"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: eventCount
                      })
                    })]
                  })
                }), "Venues".split(",").find(function (i) {
                  return i === "Artists";
                }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                  href: "/explore/artists",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("a", {
                    className: "relative mx-1 sm:w-200px w-85px cursor-pointer sm:mb-0 mb-4",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
                      className: "flex flex-col items-center bg-gradient-to-b from-gradient4 to-gradient5 sm:h-120px h-79px sm:pt-6 pt-4 sm:px-12 px-0 rounded-t-lg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white uppercase text-center sm:mb-15px mb-3",
                        children: t("key_web_artists")
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:block hidden",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 21,
                          height: 28,
                          src: "/icons/ic_search_artist_web.png",
                          alt: "artist"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:hidden block",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                          width: 15,
                          height: 20,
                          src: "/icons/ic_search_artist_web.png",
                          alt: "artist"
                        })
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                      className: "bg-black4 flex justify-center items-center sm:h-55px h-auto py-2.5 rounded-b-lg",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                        className: "md:text-xl text-xs font-bold text-white text-center",
                        children: artistCount
                      })
                    })]
                  })
                })]
              })]
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("bg-black", true), " md:block hidden"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        className: "wrapper mx-auto h-auto md:py-87px sm:py-20 py-10",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
          className: "mx-auto 2xl:max-w-1545px max-w-1280px relative",
          children: ["Venues".split(",").find(function (i) {
            return i === "Venues";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "VENUES"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/venues",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), venueList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueRef$cur;

                  if (pageVenue - 1 >= 0) {
                    pageVenue--;
                  }

                  var newIndex = pageVenue * 4;
                  flatListVenueRef === null || flatListVenueRef === void 0 ? void 0 : (_flatListVenueRef$cur = flatListVenueRef.current) === null || _flatListVenueRef$cur === void 0 ? void 0 : _flatListVenueRef$cur.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueRef$cur2;

                  if (pageVenue + 1 < Math.round(venueList.length / 4)) {
                    pageVenue++;
                  }

                  var newIndex = pageVenue * 4;
                  flatListVenueRef === null || flatListVenueRef === void 0 ? void 0 : (_flatListVenueRef$cur2 = flatListVenueRef.current) === null || _flatListVenueRef$cur2 === void 0 ? void 0 : _flatListVenueRef$cur2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListVenueRef,
              horizontal: true,
              items: venueList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingVenue && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Rooftops";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "ROOFTOPS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/rooftops",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), rooftopList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListRooftopRef$c;

                  if (pageRooftop - 1 >= 0) {
                    pageRooftop--;
                  }

                  var newIndex = pageRooftop * 4;
                  flatListRooftopRef === null || flatListRooftopRef === void 0 ? void 0 : (_flatListRooftopRef$c = flatListRooftopRef.current) === null || _flatListRooftopRef$c === void 0 ? void 0 : _flatListRooftopRef$c.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListRooftopRef$c2;

                  if (pageRooftop + 1 < Math.round(rooftopList.length / 4)) {
                    pageRooftop++;
                  }

                  var newIndex = pageRooftop * 4;
                  flatListRooftopRef === null || flatListRooftopRef === void 0 ? void 0 : (_flatListRooftopRef$c2 = flatListRooftopRef.current) === null || _flatListRooftopRef$c2 === void 0 ? void 0 : _flatListRooftopRef$c2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListRooftopRef,
              horizontal: true,
              items: rooftopList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingRooftop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Spas";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "SPAS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/spas",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), spaList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListSpaRef$curre;

                  if (pageSpa - 1 >= 0) {
                    pageSpa--;
                  }

                  var newIndex = pageSpa * 4;
                  flatListSpaRef === null || flatListSpaRef === void 0 ? void 0 : (_flatListSpaRef$curre = flatListSpaRef.current) === null || _flatListSpaRef$curre === void 0 ? void 0 : _flatListSpaRef$curre.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListSpaRef$curre2;

                  if (pageSpa + 1 < Math.round(SpaList.length / 4)) {
                    pageSpa++;
                  }

                  var newIndex = pageSpa * 4;
                  flatListSpaRef === null || flatListSpaRef === void 0 ? void 0 : (_flatListSpaRef$curre2 = flatListSpaRef.current) === null || _flatListSpaRef$curre2 === void 0 ? void 0 : _flatListSpaRef$curre2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListSpaRef,
              horizontal: true,
              items: spaList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingSpa && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Venue Beachful";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "BEACH CLUBS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/beach-clubs",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), venueBeachfulList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueBeachfu;

                  if (pageVenueBeachful - 1 >= 0) {
                    pageVenueBeachful--;
                  }

                  var newIndex = pageVenueBeachful * 4;
                  flatListVenueBeachfulRef === null || flatListVenueBeachfulRef === void 0 ? void 0 : (_flatListVenueBeachfu = flatListVenueBeachfulRef.current) === null || _flatListVenueBeachfu === void 0 ? void 0 : _flatListVenueBeachfu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueBeachfu2;

                  if (pageVenueBeachful + 1 < Math.round(venueBeachfulList.length / 4)) {
                    pageVenueBeachful++;
                  }

                  var newIndex = pageVenueBeachful * 4;
                  flatListVenueBeachfulRef === null || flatListVenueBeachfulRef === void 0 ? void 0 : (_flatListVenueBeachfu2 = flatListVenueBeachfulRef.current) === null || _flatListVenueBeachfu2 === void 0 ? void 0 : _flatListVenueBeachfu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListVenueBeachfulRef,
              horizontal: true,
              items: venueBeachfulList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingVenueBeachful && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Prefab Home";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "HOMES"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/homes",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), prefabHomeList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListPrefabHomeRe;

                  if (pagePrefabHome - 1 >= 0) {
                    pagePrefabHome--;
                  }

                  var newIndex = pagePrefabHome * 4;
                  flatListPrefabHomeRef === null || flatListPrefabHomeRef === void 0 ? void 0 : (_flatListPrefabHomeRe = flatListPrefabHomeRef.current) === null || _flatListPrefabHomeRe === void 0 ? void 0 : _flatListPrefabHomeRe.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListPrefabHomeRe2;

                  if (pagePrefabHome + 1 < Math.round(prefabHomeList.length / 4)) {
                    pagePrefabHome++;
                  }

                  var newIndex = pagePrefabHome * 4;
                  flatListPrefabHomeRef === null || flatListPrefabHomeRef === void 0 ? void 0 : (_flatListPrefabHomeRe2 = flatListPrefabHomeRef.current) === null || _flatListPrefabHomeRe2 === void 0 ? void 0 : _flatListPrefabHomeRe2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListPrefabHomeRef,
              horizontal: true,
              items: prefabHomeList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingPrefabHome && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Prefab Company";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16 mt-14",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "COMPANIES"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/companies",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), prefabCompanyList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListPrefabCompan;

                  if (pagePrefabCompany - 1 >= 0) {
                    pagePrefabCompany--;
                  }

                  var newIndex = pagePrefabCompany * 4;
                  flatListPrefabCompanyRef === null || flatListPrefabCompanyRef === void 0 ? void 0 : (_flatListPrefabCompan = flatListPrefabCompanyRef.current) === null || _flatListPrefabCompan === void 0 ? void 0 : _flatListPrefabCompan.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListPrefabCompan2;

                  if (pagePrefabCompany + 1 < Math.round(prefabCompanyList.length / 4)) {
                    pagePrefabCompany++;
                  }

                  var newIndex = pagePrefabCompany * 4;
                  flatListPrefabCompanyRef === null || flatListPrefabCompanyRef === void 0 ? void 0 : (_flatListPrefabCompan2 = flatListPrefabCompanyRef.current) === null || _flatListPrefabCompan2 === void 0 ? void 0 : _flatListPrefabCompan2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListPrefabCompanyRef,
              horizontal: true,
              items: prefabCompanyList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingPrefabCompany && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Zoos";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "ZOOS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/zoos",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), zooList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListZooRef$curre;

                  if (pageZoo - 1 >= 0) {
                    pageZoo--;
                  }

                  var newIndex = pageZoo * 4;
                  flatListZooRef === null || flatListZooRef === void 0 ? void 0 : (_flatListZooRef$curre = flatListZooRef.current) === null || _flatListZooRef$curre === void 0 ? void 0 : _flatListZooRef$curre.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListZooRef$curre2;

                  if (pageZoo + 1 < Math.round(zooList.length / 4)) {
                    pageZoo++;
                  }

                  var newIndex = pageZoo * 4;
                  flatListZooRef === null || flatListZooRef === void 0 ? void 0 : (_flatListZooRef$curre2 = flatListZooRef.current) === null || _flatListZooRef$curre2 === void 0 ? void 0 : _flatListZooRef$curre2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListZooRef,
              horizontal: true,
              items: zooList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingZoo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Animals";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16 mt-14",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "ANIMALS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/animals",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), animalList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListAnimalRef$cu;

                  if (pageAnimal - 1 >= 0) {
                    pageAnimal--;
                  }

                  var newIndex = pageAnimal * 4;
                  flatListAnimalRef === null || flatListAnimalRef === void 0 ? void 0 : (_flatListAnimalRef$cu = flatListAnimalRef.current) === null || _flatListAnimalRef$cu === void 0 ? void 0 : _flatListAnimalRef$cu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListAnimalRef$cu2;

                  if (pageAnimal + 1 < Math.round(animalList.length / 4)) {
                    pageAnimal++;
                  }

                  var newIndex = pageAnimal * 4;
                  flatListAnimalRef === null || flatListAnimalRef === void 0 ? void 0 : (_flatListAnimalRef$cu2 = flatListAnimalRef.current) === null || _flatListAnimalRef$cu2 === void 0 ? void 0 : _flatListAnimalRef$cu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListAnimalRef,
              horizontal: true,
              items: animalList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingAnimal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Parks";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "PARKS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/parks",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), parkfulList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListParkfulRef$c;

                  if (pageParkful - 1 >= 0) {
                    pageParkful--;
                  }

                  var newIndex = pageParkful * 4;
                  flatListParkfulRef === null || flatListParkfulRef === void 0 ? void 0 : (_flatListParkfulRef$c = flatListParkfulRef.current) === null || _flatListParkfulRef$c === void 0 ? void 0 : _flatListParkfulRef$c.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListParkfulRef$c2;

                  if (pageParkful + 1 < Math.round(parkfulList.length / 4)) {
                    pageParkful++;
                  }

                  var newIndex = pageParkful * 4;
                  flatListParkfulRef === null || flatListParkfulRef === void 0 ? void 0 : (_flatListParkfulRef$c2 = flatListParkfulRef.current) === null || _flatListParkfulRef$c2 === void 0 ? void 0 : _flatListParkfulRef$c2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListParkfulRef,
              horizontal: true,
              items: parkfulList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingParkful && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Casinos";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "CASINOS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/casinos",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), casinoList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListCasinoRef$cu;

                  if (pageCasino - 1 >= 0) {
                    pageCasino--;
                  }

                  var newIndex = pageCasino * 4;
                  flatListCasinoRef === null || flatListCasinoRef === void 0 ? void 0 : (_flatListCasinoRef$cu = flatListCasinoRef.current) === null || _flatListCasinoRef$cu === void 0 ? void 0 : _flatListCasinoRef$cu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListCasinoRef$cu2;

                  if (pageCasino + 1 < Math.round(casinoList.length / 4)) {
                    pageCasino++;
                  }

                  var newIndex = pageCasino * 4;
                  flatListCasinoRef === null || flatListCasinoRef === void 0 ? void 0 : (_flatListCasinoRef$cu2 = flatListCasinoRef.current) === null || _flatListCasinoRef$cu2 === void 0 ? void 0 : _flatListCasinoRef$cu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListCasinoRef,
              horizontal: true,
              items: casinoList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingCasino && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Castles";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "CASTLES"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/castles",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), castleList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListCastleRef$cu;

                  if (pageCastle - 1 >= 0) {
                    pageCastle--;
                  }

                  var newIndex = pageCastle * 4;
                  flatListCastleRef === null || flatListCastleRef === void 0 ? void 0 : (_flatListCastleRef$cu = flatListCastleRef.current) === null || _flatListCastleRef$cu === void 0 ? void 0 : _flatListCastleRef$cu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListCastleRef$cu2;

                  if (pageCastle + 1 < Math.round(castleList.length / 4)) {
                    pageCastle++;
                  }

                  var newIndex = pageCastle * 4;
                  flatListCastleRef === null || flatListCastleRef === void 0 ? void 0 : (_flatListCastleRef$cu2 = flatListCastleRef.current) === null || _flatListCastleRef$cu2 === void 0 ? void 0 : _flatListCastleRef$cu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListCastleRef,
              horizontal: true,
              items: castleList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingCastle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Resorts";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "RESORTS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/resorts",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), resortList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListResortRef$cu;

                  if (pageResort - 1 >= 0) {
                    pageResort--;
                  }

                  var newIndex = pageResort * 4;
                  flatListResortRef === null || flatListResortRef === void 0 ? void 0 : (_flatListResortRef$cu = flatListResortRef.current) === null || _flatListResortRef$cu === void 0 ? void 0 : _flatListResortRef$cu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListResortRef$cu2;

                  if (pageResort + 1 < Math.round(resortList.length / 4)) {
                    pageResort++;
                  }

                  var newIndex = pageResort * 4;
                  flatListResortRef === null || flatListResortRef === void 0 ? void 0 : (_flatListResortRef$cu2 = flatListResortRef.current) === null || _flatListResortRef$cu2 === void 0 ? void 0 : _flatListResortRef$cu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListResortRef,
              horizontal: true,
              items: resortList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingResort && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Aparthotels";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "APARTHOTELS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/aparthotels",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), aparthotelList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListAparthotelRe;

                  if (pageAparthotel - 1 >= 0) {
                    pageAparthotel--;
                  }

                  var newIndex = pageAparthotel * 4;
                  flatListAparthotelRef === null || flatListAparthotelRef === void 0 ? void 0 : (_flatListAparthotelRe = flatListAparthotelRef.current) === null || _flatListAparthotelRe === void 0 ? void 0 : _flatListAparthotelRe.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListAparthotelRe2;

                  if (pageAparthotel + 1 < Math.round(aparthotelList.length / 4)) {
                    pageAparthotel++;
                  }

                  var newIndex = pageAparthotel * 4;
                  flatListAparthotelRef === null || flatListAparthotelRef === void 0 ? void 0 : (_flatListAparthotelRe2 = flatListAparthotelRef.current) === null || _flatListAparthotelRe2 === void 0 ? void 0 : _flatListAparthotelRe2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListAparthotelRef,
              horizontal: true,
              items: aparthotelList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingAparthotel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Venue Cocktail";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "BARS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/bars",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), venueCocktailList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueCocktai;

                  if (pageVenueCocktail - 1 >= 0) {
                    pageVenueCocktail--;
                  }

                  var newIndex = pageVenueCocktail * 4;
                  flatListVenueCocktailRef === null || flatListVenueCocktailRef === void 0 ? void 0 : (_flatListVenueCocktai = flatListVenueCocktailRef.current) === null || _flatListVenueCocktai === void 0 ? void 0 : _flatListVenueCocktai.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListVenueCocktai2;

                  if (pageVenueCocktail + 1 < Math.round(venueCocktailList.length / 4)) {
                    pageVenueCocktail++;
                  }

                  var newIndex = pageVenueCocktail * 4;
                  flatListVenueCocktailRef === null || flatListVenueCocktailRef === void 0 ? void 0 : (_flatListVenueCocktai2 = flatListVenueCocktailRef.current) === null || _flatListVenueCocktai2 === void 0 ? void 0 : _flatListVenueCocktai2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListVenueCocktailRef,
              horizontal: true,
              items: venueCocktailList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingVenueCocktail && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Festivals";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16 mt-14",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "FESTIVALS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/festivals",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), festivalList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListFestivalRef$;

                  if (pageFestival - 1 >= 0) {
                    pageFestival--;
                  }

                  var newIndex = pageFestival * 4;
                  flatListFestivalRef === null || flatListFestivalRef === void 0 ? void 0 : (_flatListFestivalRef$ = flatListFestivalRef.current) === null || _flatListFestivalRef$ === void 0 ? void 0 : _flatListFestivalRef$.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListFestivalRef$2;

                  if (pageFestival + 1 < Math.round(festivalList.length / 4)) {
                    pageFestival++;
                  }

                  var newIndex = pageFestival * 4;
                  flatListFestivalRef === null || flatListFestivalRef === void 0 ? void 0 : (_flatListFestivalRef$2 = flatListFestivalRef.current) === null || _flatListFestivalRef$2 === void 0 ? void 0 : _flatListFestivalRef$2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListFestivalRef,
              horizontal: true,
              items: festivalList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingFestival && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Events";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16 mt-14",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "EVENTS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/events",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), eventList.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListEventRef$cur;

                  if (pageEvent - 1 >= 0) {
                    pageEvent--;
                  }

                  var newIndex = pageEvent * 4;
                  flatListEventRef === null || flatListEventRef === void 0 ? void 0 : (_flatListEventRef$cur = flatListEventRef.current) === null || _flatListEventRef$cur === void 0 ? void 0 : _flatListEventRef$cur.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListEventRef$cur2;

                  if (pageEvent + 1 < Math.round(eventList.length / 4)) {
                    pageEvent++;
                  }

                  var newIndex = pageEvent * 4;
                  flatListEventRef === null || flatListEventRef === void 0 ? void 0 : (_flatListEventRef$cur2 = flatListEventRef.current) === null || _flatListEventRef$cur2 === void 0 ? void 0 : _flatListEventRef$cur2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListEventRef,
              horizontal: true,
              items: eventList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_FESTIVAL,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingEvent && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          }), "Venues".split(",").find(function (i) {
            return i === "Artists";
          }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "flex flex-row sm:items-center justify-between px-16 mt-14",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "flex sm:flex-row flex-col sm:items-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                  className: "text-2xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " sm:mr-7 sm:mb-0 mb-2"),
                  children: "ARTISTS"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                href: "/explore/artists",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
                  className: "text-xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_11__/* .getClass */ .ll)("text-white", true), " uppercase cursor-pointer"),
                  children: "Discover"
                })
              })]
            }), artistList.length > 6 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
              className: "absolute z-10 top-40 w-full flex flex-row justify-between",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListArtistRef$cu;

                  if (pageArtist - 1 >= 0) {
                    pageArtist--;
                  }

                  var newIndex = pageArtist * 6;
                  flatListArtistRef === null || flatListArtistRef === void 0 ? void 0 : (_flatListArtistRef$cu = flatListArtistRef.current) === null || _flatListArtistRef$cu === void 0 ? void 0 : _flatListArtistRef$cu.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_left.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
                className: "cursor-pointer",
                onClick: function onClick() {
                  var _flatListArtistRef$cu2;

                  if (pageArtist + 1 < Math.round(artistList.length / 6)) {
                    pageArtist++;
                  }

                  var newIndex = pageArtist * 6;
                  flatListArtistRef === null || flatListArtistRef === void 0 ? void 0 : (_flatListArtistRef$cu2 = flatListArtistRef.current) === null || _flatListArtistRef$cu2 === void 0 ? void 0 : _flatListArtistRef$cu2.scrollToIndex({
                    animated: true,
                    index: newIndex
                  });
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("img", {
                  src: "/icons/".concat( false ? 0 : "", "ic_arrow_right.png"),
                  width: "40",
                  height: "40",
                  alt: "arrow"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_src_components_molecules__WEBPACK_IMPORTED_MODULE_3__/* .CardList */ .CS, {
              ref: flatListArtistRef,
              horizontal: true,
              items: artistList,
              category: _src_config__WEBPACK_IMPORTED_MODULE_4__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST,
              style: {
                marginTop: 30,
                paddingHorizontal: 54
              },
              withoutBadge: true // onItemAction={({ type, item }) => {
              //   if (type == Constants.actionType.ACTION_VIEW) {
              //     var profileId = item.profileId || item.id;
              //     router.push({
              //       pathname: "/profile/details",
              //       query: {
              //         profileId: profileId,
              //         category: Constants.categoryType.CATEGORY_ARTIST,
              //         id: item.id,
              //       },
              //     });
              //   }
              // }}

            }), isLoadingArtist && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_17___default()), {})]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      className: "sm:block hidden",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_web_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Landing);

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(82748);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1664,2427,9319,2292,2738,2460,793,3732,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);